import React from 'react'
import { ToggleButtonGroup, ToggleButton, useTheme } from '@mui/material'
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded'
import MapRoundedIcon from '@mui/icons-material/MapRounded'

function ViewToggle({ viewMode, onChange }) {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  return (
    <ToggleButtonGroup
      value={viewMode}
      exclusive
      onChange={(e, val) => val && onChange(val)}
      size="small"
      sx={{
        bgcolor: isDark ? 'rgba(15, 23, 42, 0.9)' : 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(12px)',
        borderRadius: '12px',
        p: '3px',
        gap: '2px',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
        boxShadow: isDark
          ? '0 4px 16px rgba(0,0,0,0.4)'
          : '0 4px 16px rgba(0,0,0,0.12)',
        '& .MuiToggleButtonGroup-grouped': {
          border: 'none !important',
          borderRadius: '9px !important',
          mx: '1px',
        },
        '& .MuiToggleButton-root': {
          px: 2,
          py: 0.6,
          fontWeight: 600,
          fontSize: '13px',
          textTransform: 'none',
          letterSpacing: '0.01em',
          color: isDark ? '#94a3b8' : '#64748b',
          gap: 0.75,
          transition: 'all 0.2s ease',
          '&:hover': {
            bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)',
          },
          '&.Mui-selected': {
            bgcolor: isDark ? '#818cf8' : '#4f46e5',
            color: '#ffffff',
            boxShadow: isDark
              ? '0 2px 8px rgba(129,140,248,0.4)'
              : '0 2px 8px rgba(79,70,229,0.35)',
            '&:hover': {
              bgcolor: isDark ? '#6366f1' : '#4338ca',
            },
          },
        },
      }}
    >
      <ToggleButton value="workspace" disableRipple>
        <GridViewRoundedIcon sx={{ fontSize: 16 }} />
        Workspace
      </ToggleButton>
      <ToggleButton value="map" disableRipple>
        <MapRoundedIcon sx={{ fontSize: 16 }} />
        Map
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default ViewToggle
